
const [ w, d ] = [ window, document ];

const init = () => {

  if( w.load['loadHtml'] ){
    w.load['loadHtml'].then( () => {
      // ナビゲーションカレント
      $('[data-plugin="currentMenu"]').currentMenu({mode: 0});

    });
  }

}

export default function HOUSEBUILDING() {
  $( init )
}